export const DARK_MODE_KEY = 'DARK_MODE';

export async function setDarkMode(ctx, darkMode) {
  if (darkMode) {
    document.body?.classList?.add('dark-mode');
    // Update a couple core variables.
    document.documentElement.style.setProperty(
      '--dm-primary-color',
      '#03459c',
    );
    document.documentElement.style.setProperty(
      '--dm-secondary-color',
      '#ed2a7a',
    );
    document.documentElement.style.setProperty(
      '--dm-success-color',
      '#B8E693',
    );
    document.documentElement.style.setProperty(
      '--dm-danger-color',
      '#ff1f66',
    );
  } else {
    document.body?.classList?.remove('dark-mode');

    // Remove dark mode variables.
    document.documentElement.style.removeProperty('--dm-primary-color');
    document.documentElement.style.removeProperty('--dm-secondary-color');
    document.documentElement.style.removeProperty('--dm-success-color');
    document.documentElement.style.removeProperty('--dm-danger-color');
  }

  // Store this globally for use elsewhere in the app if needed in JS.
  window.darkMode = darkMode;

  // Store in local storage.
  if (window.localStorage) {
    if (darkMode) {
      const existing = window.localStorage.getItem(DARK_MODE_KEY);
      if (existing === null) {
        await ctx.$swal({
          title: 'Dark Mode',
          html: '<p>Dark mode is a preview feature that may not be ideal in ' +
          'all areas of the application.</p>' +
          '<p>Please let us know if you encounter any areas that are ' +
          'problematic so we can make dark mode great everywhere!</p>',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: false,
          confirmButtonText: 'Continue',
          cancelButtonText: 'Leave',
        });
      }
    }
    try {
      window.localStorage.setItem(DARK_MODE_KEY, darkMode ? '1' : '0');
    } catch (err) {
      console.error('Failed to set local storage for dark mode', err);
    }
  }
}
